import React from 'react';

import {Button, SmallLoader} from '@kit';

import {Layout} from '../../components/layout';
import {LoginPopup} from '../../components/login-popup';
import {useUser} from '../../components/use-user';
import {useToggle} from '../../components/utils/hooks';
import {useRoute} from '../../lib/routes';
import {Seo} from '../../lib/seo';
import {SheetList} from './sheet-list';
import {SheetView} from './sheet-view';

import css from './sheets.module.css';

export const SheetsPage: React.FC = () => {
	const {routeName, params} = useRoute();
	const isSheet = routeName === 'sheet';

	return (
		<Layout>
			<Seo
				title={isSheet ? 'Бланк (лист) персонажа' : 'Бланки (листы) персонажей'}
				description="Электронные бланки (листы) персонажей D&D 5e по правилам 2024 с автоматическим подсчётом характеристик."
				noindex
			/>
			<RequireLogin>{isSheet ? <SheetView sheetId={params.id} /> : <SheetList />}</RequireLogin>
		</Layout>
	);
};

const RequireLogin: React.FC<{children: React.ReactNode}> = ({children}) => {
	const user = useUser();
	const [isLoginOpen, toggleLogin] = useToggle(false);

	if (user.loading) {
		return (
			<div className={css.message}>
				<SmallLoader />
			</div>
		);
	}
	if (user.id) return <>{children}</>;

	return (
		<div className={css.message}>
			<p>Бланки персонажей хранятся в вашем профиле. Войдите, чтобы создавать и открывать их.</p>
			<Button appearance="primary" onClick={toggleLogin}>
				Войти
			</Button>
			{isLoginOpen && <LoginPopup onClose={toggleLogin} />}
		</div>
	);
};
